import { useState, useEffect } from "react";

function TagsInput(props) {
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");

  function handleKeyDown(e) {
    if (e.key !== "Backspace") {
      if (e.key !== " " && e.key !== "" && e.key !== "Space") { 
        return
      }
      const value = e.target.value;
      if (value !== "" && value !== " ") {
        let tmpTags = [...tags, value.trim()]
        tmpTags = [...new Set(tmpTags)];
        setTags(tmpTags);
      }
      setInputValue("")
    }else {
      if (tags.length > 0 && inputValue === "") {
        let tmpTags = [...tags].splice(0, [...tags].length-1)
        setTags(tmpTags);
      }
    }
  }

  function handleKeyUp(e) {
    props.onCharChange(e.target.value)
  }

  function removeTag(index) {
    setTags(tags.filter((el, i) => i !== index));
  }

  useEffect(() => {
    if (props.value?.length > 0) setTags(props.value)
  }, [props.value])

  useEffect(() => {
    props.setValue(tags)
  }, [tags])

  useEffect(() => {
    if (props.resetInput) {
      setInputValue("")
      props.setResetInput(false)
    }
  }, [props.resetInput])

  return (
    <div className="tags-input-container">
      { tags.length > 0 &&
        tags.map((tag, index) => (
        <div className="tag-item" key={index}>
          <span className="text" style={{ color: "#fff", fontFamily: "Kanit"}}>{tag}</span>
          <span className="close" onClick={() => removeTag(index)}>
            &times;
          </span>
        </div>
      ))}
      <input
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        onChange={(e) => setInputValue(e.target.value)}
        value={inputValue}
        type="text"
        className="tags-input"
        placeholder="Type something"
        style={{ fontFamily: "Kanit"}}
      />
    </div>
  );
}

export default TagsInput;
